angular
	.module 'App.Module.Customer', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'customers',
				url: '/customers',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@customers":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Users.Customers'
					searchParams:
						advanced:
							configuration: SEARCH_CONFIGURATION.customer
						repositoryName: 'CustomerRepository'
						itemTemplate: '@app/customer/customer.search-result.view.html'
						filterEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.Customer.Search'
						createEnabled: ->
							return @ConfigurationService.isEnabled('Backoffice.Customer.Create')

			.state 'customers.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					shops: (ShopRepository) ->
						return ShopRepository.getEntities()
					registers: (RegisterRepository) ->
						return RegisterRepository.getEntities()
					customer: (CustomerRepository, $stateParams) ->
						query = CustomerRepository.createQuery()
						query.with 'customer_groups', 'customer_contacts', 'customer_locations', 'shops'

						return CustomerRepository.getEntity $stateParams.id, query
					integrations: (IntegrationRepository) ->
						return IntegrationRepository.getEntities()

			.state 'customers.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'CustomerController'
						controllerAs: 'vm'
						templateUrl: '@app/customer/customer.view.html'
